import React, { useState, Component, useRef, useEffect } from "react";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { useHistory, Link } from "react-router-dom";

import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";

//Files import
import { useCartContext, addProductToCart } from "../../context/CartContext";
import { useUserContext } from "../../context/UserContext";
import api from "../../Axios/api";

// MUI Components
import { Grid, Button, TextField, Typography } from "@material-ui/core";

export default function ProductDetails() {
  const classes = useStyles();
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { store } = useUserContext();
  let user = "";
  if (store) {
    user = store;
  }
  let [shippingFee, setShippingFee] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [actualCartItemsPrices, setActualCartItemsPrices] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherDiscount, setVoucherDiscount] = useState(0);
  const [productsVoucherCodes, setProductsVoucherCodes] = useState([]);
  const { dispatch, cartProducts } = useCartContext();
  const history = useHistory();
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    const cartItemsGet = cartProducts;
    let tempShippingCalculating = 0;
    if (cartItemsGet != "null" && cartItemsGet != null) {
      setCartItems([...cartItemsGet]);
      //claculate shipping fee
      cartItemsGet.forEach((item) => {
        tempShippingCalculating = tempShippingCalculating + item.shippingCost;
      });
      setShippingFee(tempShippingCalculating);
      //setting actual cart item prices in array to increase/decrease quantity
      let tempPrices = [];
      cartItemsGet.forEach((item) => {
        tempPrices.push({ price: item.price });
      });
      setActualCartItemsPrices([...tempPrices]);
      //add dicount of voucher code if applied before while adding in cart
      let tempDiscount = 0;
      cartItemsGet.forEach((item) => {
        if (item.voucherDiscount) {
          tempDiscount += item.voucherDiscount;
        }
      });
      setVoucherDiscount(tempDiscount);
      //calculate subtotal and total
      let subTotalTemp = subTotal;
      cartItemsGet.forEach((item) => {
        subTotalTemp += item.price * item.quantity;
      });
      setSubTotal(subTotalTemp);
      if (subTotalTemp > 0) {
        setTotal(subTotalTemp + tempShippingCalculating - tempDiscount);
      }
    }
  }, []);
  function isNumeric(value) {
    return /^-?\d+$/.test(value);
  }
  const changeCartItemQuantity = (e, index) => {
    let temp = cartItems;
    if (isNumeric(e.target.value)) {
      //remove the item price before added bcz new price can be low or
      //high so we remove befor price from total & subTotal
      console.log(temp[index].quantity + 1, temp[index].stockAvailable);
      if (temp[index].quantity + 1 <= temp[index].stockAvailable) {
        let temp = cartItems;
        let priceOfItemBefore = temp[index]["quantity"] * temp[index]["price"];
        let deductedSubTotal = subTotal - priceOfItemBefore;
        let deductedTotal = total - priceOfItemBefore;
        temp[index].quantity = e.target.value;
        const newPriceOfProduct =
          actualCartItemsPrices[index].price * temp[index]["quantity"];
        setCartItems([...temp]);

        //now change total and subtotal
        setSubTotal(deductedSubTotal + newPriceOfProduct);
        setTotal(deductedTotal + newPriceOfProduct);
        let tempCartProducts = cartProducts;
        tempCartProducts.forEach((product) => {
          if (product._id === temp[index]["_id"]) {
            product.quantity = e.target.value;
          }
        });
        return addProductToCart(dispatch, tempCartProducts);
      } else {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message:
            "Maximun stock available of " +
            temp[index].title +
            " is " +
            temp[index].stockAvailable,
          open: true,
        });
      }
    } else {
      setSnackBar({
        ...snackBarstate,
        type: "error",
        message: "Please enter valid number. ",
        open: true,
      });
    }
  };
  const reduceCartItemQuantity = (index) => {
    let temp = cartItems;
    if (temp[index].quantity >= 2) {
      let actualPriceOfItem = actualCartItemsPrices[index].price;
      setCartItems([...temp]);

      //now change total and subtotal
      setSubTotal(subTotal - actualPriceOfItem);
      setTotal(total - actualPriceOfItem);

      //changing quantity in local storage saved cart items
      let tempCartProducts = cartProducts;
      tempCartProducts.forEach((product) => {
        if (product._id === temp[index]["_id"]) {
          product.quantity -= 1;
        }
      });
      return addProductToCart(dispatch, tempCartProducts);
    }
  };

  const increaseCartItemQuantity = (index) => {
    // console.log("cart Items", cartItems, "cartProducts", cartProducts)
    let temp = cartItems;
    //if quantity is less than or equal to available stock
    if (temp[index].quantity + 1 <= temp[index].stockAvailable) {
      let actualPriceOfItem = actualCartItemsPrices[index].price;
      setCartItems([...temp]);

      //now change total and subtotal
      setSubTotal(subTotal + actualPriceOfItem);
      setTotal(total + actualPriceOfItem);

      //changing quantity in local storage saved cart items
      let tempCartProducts = cartProducts;
      tempCartProducts.forEach((product) => {
        if (product._id === temp[index]["_id"]) {
          product.quantity += 1;
        }
      });
      return addProductToCart(dispatch, tempCartProducts);
    } else {
      setSnackBar({
        ...snackBarstate,
        type: "error",
        message:
          "Maximun stock available of " +
          temp[index].title +
          " is " +
          temp[index].stockAvailable,
        open: true,
      });
      //setOutOfStockError("Maximun stock available of "+temp[index].title+" is "+temp[index].stockAvailable)
    }
  };

  const deleteCartItem = (index) => {
    //first we change total and subtotal
    console.log("index", index);
    let temp = cartItems;
    const priceOfDeletedItem = temp[index].price;
    const idOfDeletedItem = temp[index]._id;
    const quantityOfDeletedItem = temp[index].quantity;
    const shippingOfDeletedItem = temp[index].shippingCost;
    const colorOfDeletedItem = temp[index].color;
    setSubTotal(subTotal - priceOfDeletedItem * quantityOfDeletedItem);
    setShippingFee(shippingFee - shippingOfDeletedItem);
    setTotal(
      total - priceOfDeletedItem * quantityOfDeletedItem - shippingOfDeletedItem
    );
    //for filtering item from cart
    temp = temp.filter((product) => {
      if (product._id != idOfDeletedItem) return true;
      else return product.color != colorOfDeletedItem;
    });
    console.log("temp", temp);
    //for filtering deleted item from cartItemActualPrices
    let temp2 = actualCartItemsPrices;
    temp2 = temp2.filter((item, i) => {
      if (i !== index) return item;
    });
    setCartItems([...temp]);
    setActualCartItemsPrices([...temp2]);

    //deleting item from local storage
    let tempCartProducts = cartProducts;
    tempCartProducts = tempCartProducts.filter((product) => {
      if (product._id != idOfDeletedItem) return true;
      else return product.color != colorOfDeletedItem;
    });
    console.log("cart", tempCartProducts);
    return addProductToCart(dispatch, tempCartProducts);
  };
  const clearAllCart = () => {
    if (cartItems.length < 1) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: "No Items in cart to clear.",
        open: true,
      });
    }
    setCartItems([]);
    setShippingFee(0);
    setActualCartItemsPrices([]);
    setTotal(0);
    setSubTotal(0);
    localStorage.removeItem("CART_DATA");
    window.location.reload(false);
  };

  const openCheckoutPage = () => {
    if (cartItems.length < 1) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: "Please add products in cart to checkout.",
        open: true,
      });
    }
    if (!user.data) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: "Please login first to proceed to checkout page.",
        open: true,
      });
    }
    history.push("/checkout");
  };

  const applyVoucherCode = () => {
    if (!voucherCode) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: "Please enter voucher code!",
        open: true,
      });
    }
    let isProductPresent = false;
    let isLoading = true;
    for (const product of cartItems) {
      api
        .get(
          `/buyer/product/${product._id}/check/promocode/${voucherCode}`,
          {},
          { Headers: {} }
        )
        .then((res) => {
          isProductPresent = res.data.data.isProductPresent;
          if (isProductPresent) {
            if (!res.data.data.isProductPromotionDateValid) {
              setSnackBar({
                ...snackBarstate,
                type: "error",
                message: "Sorry this promo code has expired!",
                open: true,
              });
              return false;
            }
            let voucherDiscountPercentage = isProductPresent.discount;
            let isPromoCodeAlreadyApplied = false;
            let voucherDiscountPrice = 0;
            let promocodeData = {
              productId: isProductPresent.productId,
              discount: voucherDiscountPercentage,
              voucherCode: voucherCode,
            };
            //checking products promo code in array
            productsVoucherCodes.forEach((item) => {
              if (item.productId === promocodeData.productId) {
                return (isPromoCodeAlreadyApplied = true);
              }
            });
            //checking products promo code in local storage
            cartItems.forEach((item) => {
              if (item.voucherCode === promocodeData.voucherCode) {
                return (isPromoCodeAlreadyApplied = true);
              }
            });
            if (isPromoCodeAlreadyApplied) {
              return setSnackBar({
                ...snackBarstate,
                type: "error",
                message: "Sorry this promo code is already applied.",
                open: true,
              });
            }
            voucherDiscountPrice =
              voucherDiscount +
              product.price *
                product.quantity *
                (voucherDiscountPercentage / 100);
            setProductsVoucherCodes([...productsVoucherCodes, promocodeData]);
            setVoucherDiscount(voucherDiscountPrice);
            setTotal(total - voucherDiscountPrice);
            //changing product added in local storage add its discount & voucher code
            let tempCartProducts = cartProducts;
            tempCartProducts.forEach((product) => {
              if (product._id === isProductPresent.productId) {
                product.voucherDiscount =
                  product.price *
                  product.quantity *
                  (voucherDiscountPercentage / 100);
                product.voucherDiscountPercentage = voucherDiscountPercentage;
                product.voucherCode = voucherCode;
              }
            });
            addProductToCart(dispatch, tempCartProducts);
            return setSnackBar({
              ...snackBarstate,
              type: "success",
              message: "Promo code applied successfully.",
              open: true,
            });
          }
          if (
            !isProductPresent &&
            product === cartItems[cartItems.length - 1]
          ) {
            isLoading = false;
          }
        })
        .catch((error) =>
          console.log("error in getting data of voucher code", error)
        );
    }
    if (!isProductPresent && !isLoading) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: "Invalid voucher code !",
        open: true,
      });
    }
  };

  return (
    <div>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 17 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} style={{color:'grey'}} color="inherit" to="/">
            Home
          </Link>
          <Typography color="textPrimary">Shopping Cart</Typography>
        </Breadcrumbs>
        <Grid
          container
          style={{ justifyContent: "space-between", display: "flex" }}
        >
          <Grid lg={7} sm={12} style={{ width: "100%" }}>
            <div className={classes.cartTitleBox}>
              <Typography
                variant="h5"
                style={{ fontWeight: "bold", letterSpacing: 1, wordSpacing: 4 }}
              >
                SHOPPING CART
              </Typography>

              <Typography
                variant="p"
                style={{ color: "grey" }}
                className={classes.totalItemsText}
              >
                Total item (s): {cartItems.length}
              </Typography>
              <Button
                style={{
                  textAlign: "center",
                  paddingRight: 12,
                  display: cartItems.length > 0 ? "flex" : "none",
                }}
                variant="outlined"
                onClick={() => clearAllCart()}
              >
                <DeleteOutlinedIcon />
                Clear Cart
              </Button>
            </div>
            {/* {console.log("cart itesm", cartItems)} */}
            {/* Mapping cart items here */}
            {cartItems.map((item, index) =>
              React.cloneElement(
                <div className={classes.CartItemBox}>
                  <div className={classes.storeNameBox}>
                    <Typography variant="p" style={{ fontWeight: "bold" }}>
                      {item.storeName}
                    </Typography>
                    <Typography
                      variant="p"
                      style={{ fontSize: 13, color: "#666" }}
                    >
                      {item.category}
                    </Typography>
                  </div>
                  <div className={classes.productDetailsBox}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img className={classes.itemImageBox} src={item.image} />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingLeft: 10,
                        }}
                      >
                        <Typography
                          variant="p"
                          noWrap
                          className={classes.productTitleText}
                        >
                          {item.title}
                        </Typography>
                        <Typography
                          variant="p"
                          className={classes.productTitleText}
                          style={{ color: "grey", overFlowWrap: "break-word" }}
                          noWrap
                        >
                          Brand: {item.brand}
                          {item.color ? `, Color: ${item.color}` : null}
                          <br />
                          {item.dimensions
                            ? `Dimensions: ${item.dimensions}`
                            : null}
                        </Typography>
                        {/* Quantity Box */}
                        <div style={{ display: "flex", paddingTop: 10 }}>
                          <Button
                            style={{
                              height: 32,
                              fontSize: 20,
                              minWidth: 32,
                              borderRadius: 0,
                              backgroundColor: "#e9e9e9",
                            }}
                            onClick={() => reduceCartItemQuantity(index)}
                            // onChange={(e) => changeQuantity(e.target.value)}
                          >
                            -
                          </Button>

                          <TextField
                            id={item._id}
                            type="tel"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              style: {
                                height: 32,
                                fontSize: 20,
                                width: 28,
                                borderColor: "white",
                                padding: 0,
                                textAlign: "center",
                                fontSize: 17,
                                marginTop: 0,
                                fontWeight: "bold",
                                marginLeft: 17,
                                marginRight: 17,
                              },
                            }}
                            value={item.quantity}
                            variant="outlined"
                            padding={0}
                            style={{
                              padding: 0,
                              marginLeft: 5,
                              marginRight: 5,
                              borderColor: "white",
                            }}
                            disabled={true}
                            onChange={(e) => changeCartItemQuantity(e, index)}
                          />
                          <Button
                            style={{
                              height: 32,
                              fontSize: 20,
                              minWidth: 32,
                              borderRadius: 0,
                              backgroundColor: "#e9e9e9",
                            }}
                            onClick={() => increaseCartItemQuantity(index)}
                          >
                            +
                          </Button>
                        </div>
                      </div>
                    </div>

                    {/* Price section */}
                    <div className={classes.priceSection}>
                      <div className={classes.priceTextBoxInCartItem}>
                        <Typography className={classes.priceText} variant="h5">
                          Rs. {item.price}
                        </Typography>
                        <Typography
                          variant="p"
                          style={{ fontSize: 13, color: "#666", marginTop: 4 }}
                        >
                          Shipping:{" "}
                          <span style={{ color: "black" }}>
                            {item.shippingCost
                              ? `Rs. ${item.shippingCost}`
                              : null}
                          </span>
                        </Typography>
                      </div>
                      <Button
                        style={{
                          textAlign: "center",
                          paddingRight: 12,
                          marginTop: 20,
                          width: "100%",
                        }}
                        variant="outlined"
                        color="primary"
                        onClick={() => deleteCartItem(index)}
                      >
                        <DeleteOutlinedIcon />
                        Remove
                      </Button>
                    </div>
                  </div>
                </div>,
                {
                  key: item._id,
                }
              )
            )}
            {cartItems.length > 0 ? null : (
              <Typography style={{ marginTop: 10 }}>
                No Products Present in Cart.
              </Typography>
            )}
          </Grid>

          {/* proceed to Checkout box  */}
          <Grid
            lg={5}
            sm={12}
            style={{
              width: "100%",
              display: cartItems.length > 0 ? "block" : "none",
            }}
          >
            <div className={classes.checkoutBoxMianDiv}>
              <div className={classes.checkoutTitleBox}>
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "bold",
                    letterSpacing: 1,
                    wordSpacing: 4,
                  }}
                >
                  ORDER SUMMARY
                </Typography>
              </div>

              <div className={classes.mainCheckoutBox}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography variant="p" style={{ color: "grey" }}>
                    SubTotal ({cartItems.length} item's)
                  </Typography>
                  <Typography variant="p">Rs. {subTotal}</Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: 16,
                  }}
                >
                  <Typography variant="p" style={{ color: "grey" }}>
                    Shipping Fee
                  </Typography>
                  <Typography variant="p">Rs. {shippingFee}</Typography>
                </div>

                <div
                  style={{
                    paddingTop: 16,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    label="Enter voucher code"
                    variant="outlined"
                    inputProps={
                      // style: {
                      //   width: 290,
                      // },
                      classes.inputVoucher
                    }
                    onChange={(e) => setVoucherCode(e.target.value)}
                  />
                  <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    className={classes.newsletterBtn}
                    onClick={applyVoucherCode}
                  >
                    <Typography
                      variant="h6"
                      style={{ fontWeight: "bold", letterSpacing: 1 }}
                    >
                      APPLY
                    </Typography>
                  </Button>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: 16,
                  }}
                >
                  <Typography variant="p" style={{ color: "grey" }}>
                    Discount
                  </Typography>
                  <Typography variant="p">Rs. {voucherDiscount}</Typography>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: 16,
                  }}
                >
                  <Typography variant="h6">Total</Typography>
                  <Typography variant="h5" color="primary">
                    Rs. {total}
                  </Typography>
                </div>

                <Button
                  className={classes.goToStoreBtn}
                  style={{ fontWeight: "bold" }}
                  onClick={openCheckoutPage}
                >
                  Proceed to checkout
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
